import React from "react";
import { Icon } from "antd";
const PublicationsList = ({ publications }) => {
  return (
    <ul className="featured-publications">
      {publications.map((publication, index) => (
        <li key={index}>
          <div className="title">
            <a href={publication.link}>{publication.title}</a>
          </div>
          <div>{publication.authors}</div>
          <div>
            {publication.journal}
            {publication.link && (
              <a href={publication.link}>
                <Icon type="link" />
              </a>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default PublicationsList;
